import { Container, Grid, Text, Button } from "basis";
import { usePageTracking } from "react-event-tracker";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { CloseAccountImportantInformationList } from "./CloseAccountImportantInformationList";

export const CloseAccountCanClose = ({ state, dispatch }) => {
  usePageTracking({
    page: {
      pageType: "config-page",
      siteSection: "accounts",
      siteSubSection: "manage",
      pageTitle: "close-account",
    },
    user: {
      authenticationStatus: "logged in",
    },
  });
  const { accountInfo } = state;

  return (
    <Grid rowsGap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard
          cardName={accountInfo.cardName}
          cardEndsWith={accountInfo.cardEndsWith}
        />
      </Container>
      <SvgInline name="goodbye" size="92" />
      <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
        We're sad to see you go
      </Text>
      <Container bg="secondary.lightBlue.t25" padding="4">
        <Container bg="white" padding="6">
          <Text margin="0 0 4 0">
            <strong>
              Here’s some important information you’ll need to know about
              closing your account.
            </strong>
          </Text>
          <CloseAccountImportantInformationList
            canHaveRewardPoints={accountInfo.canHaveRewardPoints}
          />
        </Container>
      </Container>
      <Container>
        <Button
          width="196"
          onClick={() => {
            dispatch({ type: "START_REQUEST_CLICKED" });
          }}
        >
          Start request
        </Button>
      </Container>
    </Grid>
  );
};
